import { useProperty, useTranslation } from '@eti/providers';
import { analytics } from '@eti/utils';
import { useState } from 'react';
import { getPriceProps, getReadMoreLabel, getSingleChoiceProps } from '../../common/utils/productCardProps';
import { SEAT_MAP } from '../../products';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { useIllustration } from '../../common/utils/useIllustration';
import { jsx as _jsx } from "react/jsx-runtime";
const SeatMapProduct = _ref => {
  let {
    form,
    setIsSeatMapModalOpen
  } = _ref;
  const {
    t,
    nonDebugT
  } = useTranslation();
  const {
    p
  } = useProperty();
  const getMinPrice = () => {
    // logic will be added later
    const seats = [];
    if (seats.length === 0) {
      return 0;
    }
    return null;
  };
  const [isSelected, setSelected] = useState(null);
  const readMoreContent = t('seatMapReadMoreContent');
  const additionalInformation = t('seatMapAdditionalInformation');
  const description = t('seatMapDescription');
  const title = t('seatMapTitle');
  const extraProps = {
    ...getSingleChoiceProps(t, p, nonDebugT),
    onButtonChange: value => {
      if (value === 'true') {
        setIsSeatMapModalOpen(true);
        setSelected(true);
        analytics.pushToDataLayer({
          event: 'seatingVisible',
          seatingOnPage: value === 'true' ? 'YES' : 'NO'
        });
      }
    }
  };
  const illustrationUrl = useIllustration(SEAT_MAP.name);
  const productPrice = getMinPrice();
  const productOptions = {
    priceRaw: productPrice
  };
  const {
    priceLabel,
    price,
    priceSuffix
  } = getPriceProps(t, isSelected, productOptions);
  const readMoreButtonLabel = getReadMoreLabel(t);
  const productData = {
    additionalInformation,
    description,
    extraProps,
    form,
    illustrationUrl,
    isSelected,
    price,
    priceLabel,
    priceRaw: productPrice,
    // TODO change this to number whilw modifying getMinPrice()
    priceSuffix,
    productId: SEAT_MAP.id,
    productName: SEAT_MAP.name,
    readMoreButtonLabel,
    readMoreContent,
    title,
    shouldDisplayUpsell: false
  };
  return /*#__PURE__*/_jsx(ProductLayout, {
    productData: productData
  });
};
export default SeatMapProduct;